<section>
  <p-scrollTop />
  <div class="mb-4 flex gap-2 md:justify-end">
    <div>
      <p-button label="Erstellen" routerLink="/rabbits/create">
        <ng-icon name="matAddSharp"></ng-icon>
      </p-button>
    </div>
  </div>
  <div class="rounded-border overflow-hidden">
    @if (nonDeletedRabbits$ | async; as rabbits) {
    <p-dataView
      [value]="rabbits"
      [paginator]="true"
      [rows]="25"
      [rowsPerPageOptions]="[10, 25, 50, 100]"
      [pageLinks]="0"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{currentPage} / {totalPages}"
      layout="list">
      <ng-template #list let-rabbits>
        <div class="flex flex-col gap-2">
          @for (rabbit of rabbits; track rabbit.id) {
            <app-rabbit-card [rabbit]="rabbit"
              (rabbitDeleted)="onRabbitDeleted($event)" />
          }
        </div>
      </ng-template>
    </p-dataView>
    } @else {
    <div class="flex flex-col gap-2">
      @for (_ of skeletonsIterationSource; track $index) {
      <p-skeleton height="4rem" styleClass="mb-2" />
      }
    </div>
    }
  </div>
</section>
